import { BaseFieldRenderer } from './base-field-renderer';
import { FileFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class FileFieldRenderer extends BaseFieldRenderer<FileFieldJsonData> {
    protected override get defaultData(): FileFieldJsonData {
        return {
            id: '',
            type: 'file',
            label: TranslateUtils.FILE_FIELD,
            required: false,
            hiddenLabel: false,
            fileSelectText: TranslateUtils.UPLOAD_FILE
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override renderContent(fieldJsonData: FileFieldJsonData, options: RenderOptions = {}): HTMLElement {
        const elementContent = document.createElement('div');
        elementContent.classList.add('element-content');

        const fieldContainer = document.createElement('div');
        fieldContainer.classList.add('field');
        fieldContainer.classList.toggle('required', fieldJsonData.required);

        if (!fieldJsonData.hiddenLabel) {
            const label = this.renderLabel(fieldJsonData);
            fieldContainer.appendChild(label);
        }

        const fileSelectLabel = document.createElement('label');
        fileSelectLabel.classList.add('file-select-label');
        fileSelectLabel.classList.toggle('required', fieldJsonData.required);
        fileSelectLabel.setAttribute('tabindex', '0');

        const input = document.createElement('input');
        input.classList.add('input');
        input.id = `field-${fieldJsonData.id}`;
        input.type = 'file';
        input.name = fieldJsonData.id;
        if (fieldJsonData.required) {
            input.required = true;
        }
        const plainLabel = this.getPlainLabel(fieldJsonData.label);
        if (plainLabel) {
            input.dataset['label'] = plainLabel;
        }
        fileSelectLabel.appendChild(input);

        const fileSelectText = document.createElement('span');
        fileSelectText.classList.add('file-select-text');
        fileSelectText.textContent = fieldJsonData.fileSelectText || TranslateUtils.UPLOAD_FILE;
        fileSelectLabel.appendChild(fileSelectText);

        fieldContainer.appendChild(fileSelectLabel);

        const errorContainer = this.renderErrorContainer(fieldJsonData);
        fieldContainer.appendChild(errorContainer);

        if (fieldJsonData.showDescription) {
            const description = this.renderDescription(fieldJsonData);
            fieldContainer.appendChild(description);
        }

        elementContent.appendChild(fieldContainer);

        return elementContent;
    }

    protected renderInput(): HTMLElement {
        return document.createElement('div');
    }
}
